/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCurrencyLira = createReactComponent("currency-lira", "IconCurrencyLira", [
  ["path", { d: "M10 5v15a7 7 0 0 0 7 -7", key: "svg-0" }],
  ["path", { d: "M6 15l8 -4", key: "svg-1" }],
  ["path", { d: "M14 7l-8 4", key: "svg-2" }]
]);

export { IconCurrencyLira as default };
//# sourceMappingURL=IconCurrencyLira.js.map
